
// import '@/theme/pages/coreSearch.scss'
import { Component, Vue } from 'vue-property-decorator'
import Switcher from '@/modules/search/Switcher.vue'
@Component({
  components: { Switcher },
})
export default class CoreSearch extends Vue {
  searchString: string = ''

  searchOnKeyUp(e: any) {
    console.log(this.searchString)
    console.log(e)
  }
}
